import {
  useAppShellChatActions,
  useAppShellChatModel,
  useAppShellChatRouteSync,
} from '@/features/chat/appShell'

/**
 * Chat + home thread routing + rail messaging for the app shell.
 * Threads/messages hydrate from the conversations API (in-memory only).
 */
export function useAppShellChat() {
  const m = useAppShellChatModel()
  useAppShellChatRouteSync(m)
  const {
    handleRenameThread,
    handleThreadMenuAction,
    handleAccountMenuAction,
    closeThreadShare,
    handleUpdateThreadMembers,
    closePinLimitDialog,
    mainLayoutProps,
  } = useAppShellChatActions(m)

  return {
    location: m.location,
    navigate: m.navigate,
    activePrimaryKey: m.activePrimaryKey,
    homeView: m.homeView,
    setHomeView: m.setHomeView,
    homeProduct: m.homeProduct,
    setHomeProduct: m.setHomeProduct,
    threads: m.navThreads,
    displayThreadId: m.displayThreadId,
    setSelectedThreadId: m.setSelectedThreadId,
    pinnedThreadIdsForNav: m.pinnedThreadIdsForNav,
    handleThreadMenuAction,
    handleRenameThread,
    handleAccountMenuAction,
    threadShareThread: m.threadShareThread,
    closeThreadShare,
    handleUpdateThreadMembers,
    pinLimitDialogOpen: m.pinLimitDialogOpen,
    closePinLimitDialog,
    mainLayoutProps,
  }
}
